
<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-12">
                <h3>Step 1: Update Expired Documents</h3>
            </div>
            <div class="col-lg-8">
                <div class="row form-options">
                    <!--<div v-if="instance != 'United Arab Emirates'" class="col-lg-6">-->
                        <!--<identity-type :data-segment-id="dataSegmentId" :disabled="false"></identity-type>-->
                    <!--</div>-->
                    <template v-for="(docKey, index) in this.fetchKeys.requiredDocs">
                        <div class="col-lg-6" v-if="dropDownHandler(docKey)">
                            <generic-drop-down :data-segment-id="dataSegmentId" 
                                :field="{
                                    isRequired: isDocumentInputRequired(docKey),
                                    isLocked: true,
                                    title: 'Select ID Document Type',
                                    label: 'ID Document Type',
                                    placeholder: isCardType ? photoIdCardTypes.find((element) => element.value == isCardType ).text : 'Select ID Document Type',
                                    options: photoIdCardTypes,
                                    key: 'identityInfo.cardType',
                                    isDocType: isCardType
                                }"      
                                :disabled="fetchKeys.customer.identityInfo.cardType?true:false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6"
                        v-if="!showRequiredDocsExpiryOnly(docKey) && showPhotoIdFrontDocumentUK">
                            <cropper ref="cropper" 
                                :formData="formData2"
                                :isOcrField = "false"
                                :notRequired="false"
                                :field="{
                                        isRequired: isDocumentInputRequired(docKey),
                                        isLocked: true,
                                        key: docKey == 'identityInfo.passport'? 'documentInfo.identity.fileName':`${documentInfoKey(docKey)}.fileName`,
                                        originalFileNameKey:
                                              docKey == 'identityInfo.passport'? 'documentInfo.identity.originalFileName':`${documentInfoKey(docKey)}.originalFileName`,
                                        label: twoIdentityDocs() && docKey == 'identityInfo.passport'&&getField('type')!='company' ? 'PASSPORT PHOTO PAGE SCAN COPY':getField('type')=='company'?'CERTIFICATE OF INCORPORATION':'ID Front Scan Copy',
                                         placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-6" v-if="showPhotoIdBackDocumentUK &&!showRequiredDocsExpiryOnly(docKey) && docKey != 'identityInfo.passport'">
                            <id-back-cropper ref="cropper" 
                            :disabled="!allowPhotoIdBackDocumentUK"
                            :isOcrField = "false"
                            :field="{
                                isRequired: isDocumentInputRequired(docKey),
                                isLocked: true,
                                key: `${documentInfoKeyforBack(docKey)}.fileName`,
                                originalFileNameKey:`${documentInfoKeyforBack(docKey)}.originalFileName`,
                                label: 'ID Back Scan Copy',
                                 placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                            }"  
                            :formData="formData2"></id-back-cropper>
                        </div>
                        <div class="col-lg-6">
                            <date-picker
                            :field="{
                                isRequired: true,
                                isLocked: true,
                                key: documentExpiryKey(docKey),
                                label: expiryDateLable(docKey),
                                enabled:true
                            }"  
                            :formData="formData2"></date-picker>
                        </div>

                       
                    </template>
                    


                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <base-button btn-type="submit" btn-variant="primary" btn-label="CONTINUE"
                            :class="loading ? 'disabled' : ''" :disabled="loading"></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-4 mb-md-0 form-options">
                <b-form-group label="SAMPLE DOCUMENT" label-for="sampleId">
                    <img
                            style="max-width: 270px"
                            v-authenticated-image="cardImageUrl"
                    />
                </b-form-group>
            </div>
        </div>
    </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'
import axios from 'axios'

import IdentityType from '@/components/registration/IdentityType.vue'
import CardType from '@/components/registration/CardType.vue'
import GenericDropDown from '@/components/registration/GenericDropDown.vue'
import DatePicker from '@/components/registration/DatePicker.vue'

//import IdentityDocument from '@/components/registration/IdentityDocument.vue'

import Cropper from '@/components/registration/Cropper.vue'
import IdBackCropper from '@/components/registration/IdBackCropper.vue'


// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import resource from '@/api/resource'
import { ocr } from '../../utils/functions';

const viewBrandingApi = new resource('configurations/branding')
const modulesApi = new resource('configurations/modules')

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        IdentityType,
        CardType,
        GenericDropDown,
        Cropper,
        IdBackCropper,
        DatePicker
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            formData2:{
                documentValidation: null,
            },
            docExpiryLable:"Expiry Date",
            fetchDocumentTemp:null,
            dataFetch: false,
            // soundeffect: new Audio(),
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            documentUpload: null,
            documentValidation: null,
            degreeCheck:null,
            employmentCheck:null,
            redirection: true,
            validateFront : true,
            validateBack: true,
            associateData: [],
            // fieldVisaPage: {
            //     show: true,
            // },
            // fieldEmiratesID: {
            //     show: true,
            // },
            // fieldAddressProof: {
            //     show: true,
            // },
            // fieldEmiratesIDBack: {
            //     show: true,
            // },
            profileType: '',
            cardImageUrl : '',
            backScanCopyHidden: false,
            photoIdCardTypeLists: [
                {
                        text: 'No Document Type Selected',
                        value: '',
                },
                {
                    text: 'Passport',
                    value: 'passport',
                },
                {
                    text: 'Passport MRZ',
                    value: 'passportMRZ',
                },
                            {
                                text: 'Driving Licence',
                                value: 'license',
                            },
                            {
                                text: 'Biometric Residence Permit',
                                value: 'brp',
                            },
                            {
                                text: 'Qatar Residence Permit',
                                value: 'qrp',
                            },
                            {
                                text: 'UAE Old Resident Card',
                                value: 'uaeOldResidentCard',
                            },
                            {
                                text: 'UAE Smart Resident Card',
                                value: 'uaeSmartResidentCard',
                            },
                            {
                                text: 'Smart Card',
                                value: 'SMART',
                            },
                            {
                                text: 'Urdu Card',
                                value: 'URDU',
                            },
                        ],
            placeHolderField :'Select scan copy (JPG, PNG, PDF or JPEG file)',
            fileTypes:"image/*,application/pdf",
            disAllowPDF : false
        }
    }, // End of Component > data

    created() {
        // if (this.field.key == 'pepDeclaration.other') {
        // console.log(this.$store.state.registration.form.pepInfo)
        // if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.identityInfo.type
        //         },
        //         (newValue, oldValue) => {
        //             // console.log("new Value",newValue)
        //             if (newValue == 'passport' || newValue == 'passportMRZ') {
        //                 this.backScanCopyHidden = true
        //             } else {
        //                 this.backScanCopyHidden = false
        //             }
        //         }
        //     )
        // }
        // else
        // {
        //     // this.dropzoneLabel ="Please upload all relevant documents (trade license, other documents, etc)"
        // }
        // }
    },

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form', 'cardTypeOverride','getRegState','getField']),
        // computedExpiryDateLable(){
        //    return this.docExpiryLable
        // },
        isDocumentUpload(){
            return this.documentUpload
        },
      
        fetchKeys(){
            if(this.fetchDocumentTemp && this.fetchDocumentTemp.requiredDocs){
                console.log("in if loop of fetch keys")
                this.fetchDocumentTemp.requiredDocs = this.UkPassportCaseHandle(this.fetchDocumentTemp.requiredDocs)
              return this.fetchDocumentTemp
            }
            return this.fetchDocumentTemp
        },
        addressProofReq() {
            if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                return true
            }
            return false
        },
        isCardType(){
               return this.$store.getters.getField("identityInfo.cardType")
            },

        isAddrProf(){
              return this.getRegState('addressProofDocumentType')
            },

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        instance() {
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'id',
                })
                return 'Pakistan'
            }  else {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'passport',
                })
                return process.env.VUE_APP_COUNTRY
            }
        },
        showPhotoIdFrontDocumentUK() {
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            if(this.twoIdentityDocs() || this.getField('type')=='company'){
                return true 
            }
            return !!cardType;
        },
        showPhotoIdBackDocumentUK() {
            if(this.twoIdentityDocs() && this.getField('type')!='company'){
                return true
            }
            let passportTypes = ['passport', 'passportMRZ'] 
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            return !!cardType && !passportTypes.includes(cardType);
        },
        showAddressDoc()
        {
            let cardType = this.$store.getters.getField("documentInfo.fieldAddressProof.addressProofDocumentType");
            return !!cardType;
        },
        allowPhotoIdBackDocumentUK() {
            if(this.twoIdentityDocs()){
                return true
            }
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            return !!cardType && cardType != 'passport'
        },
        photoIdCardTypes(){
                let UKLists =['passport','license','brp']
                // let UAELists = ['passportMRZ','uaeOldResidentCard','uaeSmartResidentCard']
                // let QatarLists = ['passportMRZ','qrp']

                let UAELists = ['','uaeOldResidentCard','uaeSmartResidentCard']
                let QatarLists = ['','qrp']
                let PKLists = ['SMART','URDU']
                
                if( this.tempCountry =='UK'){
                    if(this.fetchKeys.requiredDocs && this.fetchKeys.requiredDocs.length < 2){
                        if(this.fetchKeys.requiredDocs[0] =='identityInfo'){
                            UKLists = ['license','brp']

                        }
                        else{
                            UKLists=['passport']
                        }
                    }
                    let array = this.photoIdCardTypeLists.filter((el)=> UKLists.includes(el.value)==true)
                    return array
                    // array.map(item => {
                    //     if (item.value.toLowerCase() === 'passportmrz') {
                    //         return { ...item, text: 'Overseas Passport' };
                    //     }
                    //     return item;
                    // });
                }
                else if(this.tempCountry == 'Qatar'){
                    return  this.photoIdCardTypeLists.filter((el)=> QatarLists.includes(el.value)==true)
                }
                else if(this.tempCountry == 'PK'){
                    return  this.photoIdCardTypeLists.filter((el)=> PKLists.includes(el.value)==true)
                }
                else{
                    return  this.photoIdCardTypeLists.filter((el)=> UAELists.includes(el.value)==true)
                }
            },
            customerType(){
                return this.form.type
            },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */

         'form.identityInfo.cardType'(value, oldValue){
            if(value){
                if(this.tempCountry == 'UK'  && this.fetchDocumentTemp.requiredDocs &&this.fetchDocumentTemp.requiredDocs.length>1){
                if(value =='passport'){
                    this.fetchDocumentTemp.requiredDocs = ['identityInfo.passport','identityInfo']
                }else if(value !='passport'){
                    this.fetchDocumentTemp.requiredDocs =  ['identityInfo','identityInfo.passport']
                }
                }
                
            }
         }
       
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    async mounted() {
        // if(this.tempCountry == 'UK' && this.isCardType) {
        //             if(this.isCardType == 'license') {
        //                 this.proofOfAddressCardTypesUK = this.proofOfAddressCardTypesUK.filter(el => el.text != 'Driving Licence');
        //             }
        //         }
        await this.getModuleData()
        console.log("out form mudule data")
        // if(this.liveness)
        // {
        //     this.placeHolderField = 'Select scan copy (JPG, PNG or JPEG file)'
        //     this.fileTypes = "image/*"
        //     this.disAllowPDF = true
        // }
        // if(this.$route.path.includes('deep') && !this.getField('basicInfo.firstName') )
        // {
            await this.getFormData()
        // }
        this.getBrandingData()

        //save token in the state

        // console.log(this.$route.params)
        // this.country == process.env.VU
    }, // End of Component > watch

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
         
         isDocumentInputRequired(docKey){
            //  if(this.tempCountry =='UK' && !this.fetchKeys.identityInfo.cardType){
            //     return false
            //  }
            //  else if((this.tempCountry =='Qatar' || this.tempCountry =='UAE' ) && !this.fetchKeys.identityInfo.cardType && docKey == 'identityInfo'){
            //     return false
            //  }
            // console.log("docKey :", docKey)
            // console.log("filename exits ? ",_.get(this.fetchKeys.customer,`${this.documentInfoKey(docKey)}.fileName`),`${this.documentInfoKey(docKey)}.fileName`)
            // console.log("isCardType",this.isCardType)
            if(this.dropDownHandler(docKey) && ( this.getField(`${this.documentInfoKey(docKey)}.fileName`)|| this.isCardType)){
                // console.log(" 1 reurning true ")
                return true
            } 
            else if (!_.get(this.fetchKeys.customer,`${this.documentInfoKey(docKey)}.fileName`)){
                // console.log("reurning false ")
                return false
             }
            //  console.log("2 reurning true ")
             return true
         },
         expiryDateLable(value){
            let array = ['identityInfo','identityInfo.passport']
           console.log("documentExpiryKey(value) value",value)
           if(array.includes(value) && this.getField('type')!='company'){
                if(value.split(".").includes("passport")){
                    console.log("1")
                    return 'Passport ID Expiry Date'
                }else{
                    console.log("2")
                    return 'National ID Expiry Date'
                }
                // return 'Expiry Date'
           }
           else{
                   return 'CERTIFICATE OF INCORPORATION Expiry Date'
           }
        //    return "Expire Date"
        },
        dropDownHandler(docKey){
            console.log("dockey",docKey)
            if(this.isDocumentUpload && this.getField('type')!='company'){
               if(this.tempCountry == 'UK' && this.isCardType =='passport' && docKey == 'identityInfo.passport'  ){
                return true
               }
               else if( this.tempCountry == 'UK' && !this.isCardType 
                       && docKey == 'identityInfo.passport' && this.fetchKeys.requiredDocs &&this.fetchKeys.requiredDocs.length<2){
                return true //if no document type selected and passport expiry
               }
               else if(this.tempCountry == 'UK' && this.isCardType !='passport' && docKey == 'identityInfo'){
                return true
               }
               else if(this.tempCountry != 'UK' && docKey == 'identityInfo'){
                return true
               }
            }

            return false
        },
        UkPassportCaseHandle (requiredDocs){
            console.log("inside uk case handler")
            if(this.tempCountry=='UK'&& this.isCardType == 'passport'&& requiredDocs.length >1){
                    requiredDocs = ['identityInfo.passport','identityInfo']
              }else if(this.tempCountry=='UK'&& this.isCardType != 'passport'&& requiredDocs.length >1){
                requiredDocs = ['identityInfo','identityInfo.passport']
              }
                        return requiredDocs
        },
         documentInfoKey(docKey){
            let ListForEmId = ['uaeOldResidentCard','uaeSmartResidentCard','qrp']
            if (   this.photoIdCardTypes.find((el)=> ListForEmId.includes(el.value)==true) 
                && docKey == 'identityInfo' && this.getField('type')!='company'){
                return "documentInfo.fieldEmiratesID"
            } 
            return "documentInfo.identity"
        },
        documentInfoKeyforBack(dockey){
            let ListForEmId = ['uaeOldResidentCard','uaeSmartResidentCard','qrp']
            if (this.photoIdCardTypes.find((el)=> ListForEmId.includes(el.value)==true)){
                return "documentInfo.fieldEmiratesIDBack"
            } 
            return "documentInfo.identityBack"
        },
         showRequiredDocsExpiryOnly(docKey){
            if(!this.documentUpload){
                return true
            }
            // else if(this.getField('type')=='company'){
            //     return false
            // }
            else if(this.tempCountry == 'PK' && docKey == 'identityInfo.passport'){
                return true 
            }
            else if ( this.tempCountry == 'UK' && this.getField("identityInfo.cardType") 
                     && ( this.getField("identityInfo.cardType")!='passport' && docKey =='identityInfo.passport')||
                         (this.getField("identityInfo.cardType") =='passport' && docKey =='identityInfo')){
                return true
            }
            else{
                console.log("reach show expiry for ",docKey)
                return false
            }
            
            
         },
         documentExpiryKey(value){
            let array = ['identityInfo','identityInfo.passport']
           console.log("documentExpiryKey(value) value",value)
           if(array.includes(value)){
                //  value = this.UkPassportCaseHandlerForExpiryKey(value)
                // if(value.split(".").includes("passport")){
                //     // console.log("1")
                //     // this.docExpiryLable =  'Passport ID Expiry Date'
                // }else{
                //     // console.log("2")
                //     // this.docExpiryLable =  'National ID Expiry Date'
                // }
                return `${value}.expiryDate`
           }
        //    else if(value == 'occupationInfo'){
        //         this.docExpiryLable =  'CERTIFICATE OF INCORPORATION Expiry Date'
        //         return `${value}.tradeLicenseExpiryDate`
        //    }
        },
         twoIdentityDocs(){
                let countries = ['UAE','Qatar']
                if(countries.includes(this.tempCountry)){
                  return 'passportMRZ'
                }
                return false
             },
         isGenericDropdownCountry() {
            if (
                (this.country == 'United Arab Emirates' ||
                this.tempCountry == 'UK' ||
                this.tempCountry == 'Qatar') && this.customerType != 'company'
            ) {
                return true
            }
            return false
        },
         isOcrCountry(){
                if( this.country == 'United Arab Emirates' || this.country == 'Pakistan' ||  (this.tempCountry == 'UK' || this.tempCountry == 'Qatar')){
                    return true
                }
                return false
          },
        
        onError(file,message,xhr)
        {
            // console.log('on upload error',file,message,xhr)
            this.$refs.myVueDropzone.removeFile(file)
            console.log("File removed!")
            this.$store.commit('setError', message)

        },
        onFileRemove(file) {
            console.log('route name in remove file',this.$route.name)

            if(this.$route.name=='deep-registration-upload-document')
            {
                console.log('on file remove', file)
                let arr = []
                if (this.$store.state.registration.form.documentInfo.otherDocuments !== undefined) {
                    if(this.$store.state.registration.form.documentInfo.otherDocuments.length > 1)
                    {
                        this.$store.state.registration.form.documentInfo.otherDocuments.forEach((value, index) => {
                            console.log('value', value)
                            console.log('index', index)
                            if (value.uploadID == file.upload.uuid) {

                            } else {
                                let fileObj = {
                                    'fileName': value.fileName,
                                    'originalFileName': value.originalFileName,
                                    'uploadID': value.uploadID
                                }
                                arr.push(fileObj)
                                this.updateOriginalFileName(arr)

                            }
                        });
                    }
                    else
                    {
                        this.updateOriginalFileName(arr)
                    }
                }
            }

        },
        afterComplete(file) {
            console.log('func files-----', file);
            let response = JSON.parse(file.xhr.response)
            console.log(response.data.fileName)
            console.log('org name---', file.name)

            let fileObj = {
                'fileName': response.data.fileName,
                'originalFileName': file.name,
                'uploadID': file.upload.uuid
            }
            let arr = []
            if (this.$store.state.registration.form.documentInfo.otherDocuments !== undefined) {
                arr = this.$store.state.registration.form.documentInfo.otherDocuments
            }
            arr.push(fileObj)
            this.updateOriginalFileName(arr)
        },
        updateOriginalFileName(newValue) {
            this.$store.commit('updateField', {
                key: 'documentInfo.otherDocuments',
                value: newValue,
            })
            console.log('other Docs---', this.$store.state.registration.form.documentInfo.otherDocuments)

        },
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        console.log('LIVENESS', data.data)
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                        this.riskFactor = data.data.riskFactor
                        this.documentUpload = data.data.documentUpload
                        this.documentValidation = data.data.documentValidation
                        this.formData2.documentValidation = data.data.documentValidation
                        this.degreeCheck = data.data.degreeCheck
                        this.employmentCheck = data.data.employmentCheck
                        // if (this.documentUpload == false ) {
                        //     if(this.$store.getters.form.type!='company')
                        //     {
                        //         this.$router.push({name: 'deep-registration-record-video',params:{source:this.$route.params.source}})
                        //     }
                        //     else
                        //     {
                        //         this.$router.push({name: 'deep-registration-setup-profile',params:{source:this.$route.params.source}})

                        //     }
                        // }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async onSubmit() {
            // if (this.validateBack && this.validateFront) {

            //     // validate the form fields
                const result = await this.$validator.validateAll()

            //     // Check if validation fails
                if (result) {
                    // this.$store.commit('setLoading', true)
                    this.$router.push({name: 'document-upload-preview'})

                    // console.log('public registration')
                    // console.log(this.$route.meta.publicRegistration)

                    // this.soundon()

                    // if (this.$route.meta.publicRegistration === true) {
                    //     if ((this.documentUpload === false || this.liveness === true) && this.$store.getters.form.type!='company') {
                    //         this.$router.push({
                    //             name: 'deep-registration-record-video',
                    //             params: {
                    //                 dataSegmentId: this.dataSegmentId,
                    //                 token: this.$route.params.token,
                    //                 source:this.$route.params.source
                    //             },
                    //         })
                    //     }
                    //     else {
                    //         this.$router.push({
                    //             name: 'deep-registration-setup-profile',
                    //             params: {
                    //                 dataSegmentId: this.dataSegmentId,
                    //                 token: this.$route.params.token,
                    //                 source:this.$route.params.source
                    //             },
                    //         })
                    //     }
                    // } else {
                    //     this.$router.push('/register-customer/record-video')
                    // }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                    // this.$store.commit('setLoading', false)
                }
            // } else {
            //     this.$store.commit('setError', 'Your uploaded document has not been verified by our system, please try again.')
            // }
        }, // End of onSubmit() method
        // soundon() {
        //     const sound =
        //         'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
        //     this.soundeffect.src = sound
        //     this.$store.commit('updateField', {
        //         key: 'soundSrc',
        //         value: this.soundeffect,
        //     })
        // },

        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
            if(data.data.bgImages)
            {
                if(this.$store.getters.form.type!='company')
                {
                    this.cardImageUrl =  'logo/'+data.data.bgImages.idCard.fileName
                }
                else
                {
                    this.cardImageUrl =  'logo/'+data.data.bgImages.companyLicense.fileName
                }
            }
        },

        async getFormData() {
            try {
                    console.log("getformDATa")
                //fetch data from the url & send request
            //   if(this.getField("type")){
                let { data } = await request({
                    url: `/customers/fetch-document-upload-temp`,
                    method: 'get',
                    params: {
                        token: this.$route.params.token,
                    },
                })
                let isData = data && data.data
                console.log('data.data', data.data)
                       if(isData ){
                           this.fetchDocumentTemp = data.data
                           if (this.fetchDocumentTemp.isRejected && this.fetchDocumentTemp.rejectedDocs){
                             this.fetchDocumentTemp.requiredDocs = this.fetchDocumentTemp.rejectedDocs
                            }
                           if(!this.getField("identityInfo.cardType")){
                                this.$store.commit('updateField', {
                                    key: 'identityInfo.cardType',
                                    value: this.fetchDocumentTemp.customer.identityInfo.cardType,
                                })
                           } 
                        this.$store.commit('updateField', {
                            key: 'type',
                            value: this.fetchDocumentTemp.type,
                        })
                        this.$store.commit('updateField', {
                            key: 'contactInfo.email',
                            value: this.fetchDocumentTemp.contactInfo.email,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: this.fetchDocumentTemp.basicInfo.firstName,
                        })
                           
                        // this.profileType = data.data.profileType
                        // this.setMultipleUploadDocuments(data.data.profileType)
                         }
                    if (process.env.VUE_APP_COUNTRY != 'Pakistan') {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.type',
                            value: 'passport',
                        })
                        
                           
                        // this.profileType = data.data.profileType
                        // this.setMultipleUploadDocuments(data.data.profileType)
                    }else{
                        this.$store.commit('updateField', {
                            key: 'identityInfo.type',
                            value: 'id',
                        })
                    }

                // }

                // console.log(data.data)
            } catch (error) { }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        async getRecords(association) {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/${association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.associateData = data.data
                console.log('this.associateData', this.associateData)
            } catch (error) {
                console.log(error)
            }
        }, // End of getRecords() method
        setMultipleUploadDocuments(profileType) {
            console.log('Setting Data for UAE for profile type : ', profileType)

            if (profileType == 'Citizen') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
            } else if (profileType == 'Non-resident (tourist)') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
                this.fieldEmiratesID.show = false
                this.fieldEmiratesIDBack.show = false
                // this.fieldEmiratesID.isRequired = false
            } else {
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
